module.exports = __webpack_public_path__ + "img/8.f752c6f1.jpg";;
if (typeof window !== 'undefined') {
(window.__IMAGE_SIZES__ || (window.__IMAGE_SIZES__ = {}))[module.exports] = {"width":571,"height":327,"variants":[{"file":"img/8-480w.a6280aa81b65.webp","width":480},{"file":"img/8-571w.bbc766716d48.webp","width":571}]};
}